import { captureException } from '@sentry/react';
import { enqueueSnackbar } from '~/utils/notifications';

/** Extract a user-friendly error message from an unknown error */
export const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'Unknown error';
};

export const handleError = (
    error: unknown,
    errorMessage?: string,
    key?: string
) => {
    console.error(error);
    captureException(error);
    if (errorMessage) {
        enqueueSnackbar(errorMessage, {
            variant: 'error',
            key,
        });
    }
};
